@if (column(); as column) {
  @if (model(); as model) {
    @switch (column.key) {
      @case (getColumnKey('filename')) {
        <div class="flex items-center gap-3">
          <app-image-thumbnail>
            <img
              class="object-contain"
              loading="lazy"
              [alt]="model.alt"
              [fill]="true"
              [ngSrc]="model.thumbnailUrl" />
          </app-image-thumbnail>

          <div>{{ model.filename }}</div>
        </div>
      }

      @case (getColumnKey('size')) {
        <div class="flex flex-wrap gap-3">
          {{ model.size | filesize }}
        </div>
      }

      @default {
        <app-table-body-no-reference-cell [columnKey]="column.key" />
      }
    }
  }
}
